import React, { useState, useEffect } from 'react';
import { Modal, Button, Container, Row, Col, Table } from 'react-bootstrap';
import Swal from "sweetalert2";
import PoServices from '../../../services/PoServices';
import RepairPoServices from '../../../services/RepairPoServices';


const ReceivedOrderModal = ({ show, handleClose, test, admin }) => {
  const [poItems, setPoItems] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log("admin112", admin)

  useEffect(() => {
    if (admin && admin._id && show) {
      fetchPOItems(admin._id);
    }
  }, [admin, show]);

  const fetchPOItems = async (poId) => {
    setLoading(true);
    try {
      const res = await RepairPoServices.AllItemsByPoId(poId);
      if (res?.data?.length > 0) {
        setPoItems(res.data);
      } else {
        setPoItems([]);
      }
    } catch (error) {
      console.error('Error fetching PO items:', error);
      Swal.fire('Error', 'Failed to fetch PO items.', 'error');
    } finally {
      setLoading(false);
    }
  };
const formatQty = (value, unitName) => {
  const num = Number(value);
  const qty = isNaN(num) ? "0.00" : num.toFixed(2);
  return unitName ? `${qty} ${unitName}` : qty;
};

  return (
    <Modal className="fade" show={show} onHide={handleClose} size="lg">
      <Modal.Header>
        <Modal.Title>
          <i className="fas fa-edit"></i> Received Order Status
        </Modal.Title>
        <Button variant="" className="btn-close" onClick={handleClose}></Button>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col md="12">
              {loading ? (
                <div className="text-center my-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2 text-muted">Loading PO items...</p>
                </div>
              ) : poItems.length > 0 ? (
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Part No</th>
                      <th>Description</th>
                      <th>Qty</th>
                      <th>Received Qty</th>
                      <th>Pending Qty</th>
                      <th>Status</th>
                      <th>MRV No</th>
                    </tr>
                  </thead>
                  <tbody>
                    {poItems.map((item, idx) => (
                      <tr key={item._id}>
                        <td>{idx + 1}</td>
                        <td>{item?.partNo || 'N/A'}</td>
                        <td>{item?.description || 'N/A'}</td>
                        <td>{item?.approveQty || 0}</td>
                        <td>{item?.qtyRecived || 0}</td>
                        <td>
                          {formatQty(
                            Math.max(
                              (Number(item?.approveQty) || 0) -
                              (Number(item?.qtyRecived) || 0),
                              0
                            ),
                            item?.inventory?.masterItem?.unit?.name
                          )}
                        </td>

                        <td>{item?.status === 'approved' ? 'Order Pending' : item?.status}</td>
                        <td>{item?.repairMrvNo}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p className="text-center text-muted">No PO items available.</p>
              )}
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger light" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReceivedOrderModal;
